export default "__VITE_ASSET__CuBCCNkW__"